import React, { useEffect, useState } from 'react';
import TextInput from '../../../components/form/TextInput';

function AddYoutubeUrl({ onAdded, index }) {
  const youtubeRegex =
    /^(https?:\/\/)?(www\.)?((youtube\.com\/(watch\?v=|embed\/|v\/|user\/\w+\/)|youtu\.be\/)|youtube\.com\/shorts\/)[^\s]+$/;

  const [value, setValue] = useState('');
  const [error, setError] = useState('');

  const onChange = (e) => {
    setValue(e.target.value);
  };

  const onBlur = (e) => {
    if (!value || !youtubeRegex.test(value)) {
      setError('Field link youtube .');
    } else {
      setError('');
    }
  };

  const handleSubmit = () => {
    if (!value || !youtubeRegex.test(value)) {
      setError('Field link youtube .');
    }
    if (!error && value !== '') {
      document.getElementById('closeModal-' + index).click();
      onAdded(value, index);
      setError('');
      setValue('');
    }
  };

  useEffect(() => {
    const myModalEl = document.getElementById(`addYoutubeUrlModal-${index}`);
    myModalEl.addEventListener('hidden.bs.modal', () => {
      setError('');
      setValue('');
    });
  }, []);

  return (
    <div className="modal" tabIndex="-1" id={`addYoutubeUrlModal-${index}`}>
      <div className="modal-dialog modal-md">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Tambahkan Link Youtube</h5>
            <button
              id={`closeModal-${index}`}
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <TextInput
              onChange={onChange}
              onBlur={onBlur}
              value={value}
              type="text"
              isRequired={true}
              label="Link youtube"
              isError={error}
              errorMessage={error}
            />
          </div>
          <div className="modal-footer justify-content-center">
            <button
              type="button"
              onClick={handleSubmit}
              className="btn btn-primary bg-blue-1 rounded-1">
              <i className="fa fa-plus mr-10"></i>
              Tambahkan
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddYoutubeUrl;
